let files = require.context('./', true, /\.vue$/)
export default files.keys().map(key => {
  return files(key).default || files(key)
}).filter(v => v.isModule)